import { IDictionary } from 'types';

export interface IDataSourceProps {
  parentColumns: IDictionary;
  childrenColumns: IDictionary;
  groupColumnKey: string;
  groupHeader: string;
  gqlMethod: string;
  sortingType: string;
  filterType: string;
}

export enum SpendTypeEnum {
  THIRD_PARTY = 'thirdParty',
  PERSONNEL = 'personnel',
}
export interface ITransactionItem {
  id: number;
  apSpendCategoryL1: string;
  apSpendCategoryL2: string;
  categoryL1Code?: number;
  categoryL2Code?: number;
}
export interface IRuleItem {
  ruleId: number;
  categoryL1Code?: number;
  categoryL2Code?: number;
  apSpendCategoryL1?: string;
  apSpendCategoryL2?: string;
}

export interface ITaxonomyItem {
  apL1Category: string;
  apL2Category: string;
  isPersonnel: boolean;
  l1Code: number;
  l2Code: number;
}

export interface ISpendDataInfo {
  count: number;
  lastUpdatedDate: string;
}
